import {useProduct} from "./useProduct";
import {RemoteDataUI} from "../../common/ui/RemoteDataUI";
import {Spinner} from "react-bootstrap";
import React from "react";
import {ProductDetail} from "../ui/ProductDetail";
import {useParams} from "react-router-dom";
import {useRelatedProducts} from "./useRelatedProducts";
import {ProductSwiperBis} from "../../features/product/ui/ProductSwiperBis";
import {CatalogItemCard} from "../../common/ui/CatalogItemCard";
import {PriceWithFallback} from "../../common/ui/PriceWithFallback";

export const ProductPage = () => {
    const {productCode} = useParams();
    const {productRemoteData} = useProduct(productCode);
    const {relatedProductsRemoteData} = useRelatedProducts(productCode);


    return (
        <main className="container-fluid">
            <RemoteDataUI remoteData={productRemoteData}>
                <RemoteDataUI.Pending>
                    <div className="text-center"><Spinner/></div>
                </RemoteDataUI.Pending>

                <RemoteDataUI.Success>
                    {product => <ProductDetail product={product}/>}
                </RemoteDataUI.Success>
            </RemoteDataUI>

            <section style={{marginTop: '100px'}}>

                <RemoteDataUI remoteData={relatedProductsRemoteData}>
                    <RemoteDataUI.Pending>
                        <div className="text-center"><Spinner/></div>
                    </RemoteDataUI.Pending>

                    <RemoteDataUI.Success>
                        {relatedProducts => (
                            <ProductSwiperBis title="PRODUCTOS RELACIONADOS" products={relatedProducts}>
                                <ProductSwiperBis.Item>
                                    {product =>
                                        <CatalogItemCard data={{catalogItem: product}}>
                                            <CatalogItemCard.Price>
                                                <PriceWithFallback data={{sellingPrice: product.price?.bestPrice, basePrice: product.price?.value}}/>
                                            </CatalogItemCard.Price>
                                        </CatalogItemCard>
                                    }
                                </ProductSwiperBis.Item>
                            </ProductSwiperBis>
                        )}
                    </RemoteDataUI.Success>
                </RemoteDataUI>
            </section>
        </main>
    );
}